import React from 'react';
import styles from './subsectionHeader.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import colors from 'src/styles/colors.module.scss';

interface Props {
    title: string;
    body: string;
}

export default function SubsectionHeader({ title, body }: Props): JSX.Element {
    return (
        <div className={styles.subsectionHeader}>
            <Typography variant={TypographyVariants.HEADING_S} className={colors.textStrong} component="h2">
                {title}
            </Typography>
            <Typography variant={TypographyVariants.BODY} component="p">
                {body}
            </Typography>
        </div>
    );
}
